import { render, staticRenderFns } from "./PageUnauthorized.vue?vue&type=template&id=dc20211a&scoped=true&"
import script from "./PageUnauthorized.vue?vue&type=script&lang=js&"
export * from "./PageUnauthorized.vue?vue&type=script&lang=js&"
import style0 from "./PageUnauthorized.vue?vue&type=style&index=0&id=dc20211a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc20211a",
  null
  
)

export default component.exports